import "core-js/modules/es.string.replace-all.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "wrapper-outer",
  style: {
    "line-height": "1.5"
  }
};
const _hoisted_2 = {
  class: "div-086"
};
const _hoisted_3 = {
  class: "position-div"
};
const _hoisted_4 = {
  class: "postion-content"
};
const _hoisted_5 = {
  class: "postion-left"
};
const _hoisted_6 = {
  class: "postion-center"
};
const _hoisted_7 = {
  class: "postion-right"
};
const _hoisted_8 = {
  class: "pos-selected"
};
const _hoisted_9 = {
  class: "position-collapse"
};
const _hoisted_10 = {
  class: "position-collapse-title"
};
const _hoisted_11 = {
  class: "position-collapse-btn"
};
const _hoisted_12 = {
  class: "position-file-img"
};
const _hoisted_13 = {
  class: "position-file-name"
};
const _hoisted_14 = {
  class: "position-file-btn"
};
const _hoisted_15 = {
  class: "submit-div"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_tree = _resolveComponent("el-tree");
  const _component_DArrowRight = _resolveComponent("DArrowRight");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_sensitive_words_dialog = _resolveComponent("sensitive-words-dialog");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_collapse_item = _resolveComponent("el-collapse-item");
  const _component_el_collapse = _resolveComponent("el-collapse");
  const _component_el_form = _resolveComponent("el-form");
  const _component_my_upload = _resolveComponent("my-upload");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
    ref: "formRef",
    "label-position": 'top',
    "label-width": "80px",
    model: _ctx.demand,
    rules: _ctx.rules,
    class: "form-div"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, {
      class: "prop-col"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 14
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "素材名称",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            class: "prop-val-row"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _ctx.demand.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.demand.name = $event),
              placeholder: "请输入素材名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "需求人",
          prop: "=userName"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            class: "prop-val-row prop-val-text"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.userInfo.userName) + "    " + _toDisplayString($setup.userInfo.deptName), 1)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_row, {
      class: "prop-col"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 14
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          class: "prop-val-row"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "素材有效期",
              prop: "validDate"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_row, null, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  modelValue: _ctx.demand.validDate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.demand.validDate = $event),
                  "value-format": "YYYY-MM-DD HH:mm:ss",
                  format: "YYYY-MM-DD",
                  type: "daterange",
                  disabledDate: $setup.disabledDate,
                  "default-time": $setup.defaultRangeTime,
                  "range-separator": "~",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期"
                }, null, 8, ["modelValue", "disabledDate", "default-time"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "联系方式"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            class: "prop-val-row prop-val-text"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, _toDisplayString($setup.userInfo.mobile), 1)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form_item, {
      label: "选择投放运营点位",
      prop: "position",
      class: "position-form"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_input, {
        modelValue: _ctx.filterText,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.filterText = $event),
        placeholder: "搜索运营位",
        style: {
          "margin-top": "5px"
        }
      }, null, 8, ["modelValue"]), _createElementVNode("div", {
        class: "left-tree",
        id: "posTree",
        style: _normalizeStyle({
          'max-height': $setup.maxHeight
        })
      }, [_withDirectives(_createVNode(_component_el_tree, {
        data: _ctx.posTree,
        ref: "treeLeft",
        "show-checkbox": "",
        "node-key": "id",
        "filter-node-method": $setup.filterNode,
        "default-checked-keys": _ctx.defaultPosChecked,
        onCheckChange: $setup.handleCheck,
        props: $setup.defaultProps
      }, null, 8, ["data", "filter-node-method", "default-checked-keys", "onCheckChange", "props"]), [[_directive_loading, $setup.positionLoading]])], 4)]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
        plain: "",
        type: "primary",
        onClick: $setup.left2right
      }, {
        default: _withCtx(() => [_cache[4] || (_cache[4] = _createTextVNode(" 选中 ", -1)), _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_DArrowRight)]),
          _: 1
        })]),
        _: 1
      }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_row, {
        span: 24,
        class: "right-head-row"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_cache[6] || (_cache[6] = _createTextVNode(" 已选择运营点位 ", -1)), _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          plain: "",
          onClick: $setup.clearPosSelected
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("清空已选", -1)]))]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_sensitive_words_dialog, {
          "assets-ids": $setup.getAssetsIds
        }, null, 8, ["assets-ids"])])]),
        _: 1
      }), _createElementVNode("div", {
        class: "right-div",
        style: _normalizeStyle({
          'max-height': $setup.maxHeight
        })
      }, [_createVNode(_component_el_collapse, {
        accordion: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.positions, (item, index) => {
          return _openBlock(), _createBlock(_component_el_collapse_item, {
            name: item.positionId,
            key: index
          }, {
            title: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_popover, {
              placement: "top-start",
              width: 400,
              trigger: "hover",
              content: item.labels.replaceAll('^', ' > ')
            }, {
              reference: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.label), 1)]),
              _: 2
            }, 1032, ["content"])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              circle: "",
              link: "",
              onClick: _withModifiers($event => $setup.handlerUpload(index, item), ["stop"])
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" 上传 ", -1)]))]),
              _: 1
            }, 8, ["onClick"]), _createVNode(_component_el_button, {
              type: "danger",
              size: "small",
              circle: "",
              link: "",
              onClick: _withModifiers($event => $setup.removePosition(index, item.positionId), ["stop"])
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" 删除 ", -1)]))]),
              _: 1
            }, 8, ["onClick"])])])]),
            default: _withCtx(() => [_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.files, (f, i) => {
              return _openBlock(), _createElementBlock("div", {
                key: i,
                class: "position-file"
              }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString(f.fileName), 1)]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_button, {
                type: "danger",
                size: "small",
                link: "",
                circle: "",
                onClick: $event => $setup.removeFile(i)
              }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode(" 删除 ", -1)]))]),
                _: 1
              }, 8, ["onClick"])])]);
            }), 128))])]),
            _: 2
          }, 1032, ["name"]);
        }), 128))]),
        _: 1
      })], 4)])])]),
      _: 1
    })])]),
    _: 1
  }, 8, ["model", "rules"]), _createElementVNode("div", _hoisted_15, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
    type: "primary",
    round: "",
    onClick: $setup.handleSubmit
  }, {
    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("提交审核", -1)]))]),
    _: 1
  }, 8, ["onClick"])), [[_directive_loading, _ctx.upLoading]])])]), _createVNode(_component_my_upload, {
    visible: $setup.fileDialogShow,
    "onUpdate:visible": _cache[3] || (_cache[3] = $event => $setup.fileDialogShow = $event),
    demand: _ctx.currentPosition,
    onUploadSuccess: $setup.handlerUploadSuccess
  }, null, 8, ["visible", "demand", "onUploadSuccess"])], 64);
}